import React from 'react';
import { interpolateLabel } from '../../utils/calculationEngine';

const NoteWidget = ({ field, nameValues = {} }) => {
    const text = interpolateLabel(field.description || field.label || '', nameValues, '', true);
    return (
        <div className="flex gap-3 p-4 text-blue-900 border border-blue-100 rounded-lg bg-blue-50">
            <div className="shrink-0 mt-0.5">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div className="text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
};

export default NoteWidget;
